"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiConnection = exports.RegistrationData = void 0;
const resources_1 = require("./resources");
const dto_1 = require("./dto");
class RegistrationData {
  static registerByEmail(email, password) {
    var result = new RegistrationData();
    result.email = email;
    result.password = password;
    return result;
  }
  static registerByExternalAccess(email, password) {
    var result = new RegistrationData();
    result.email = email;
    result.password = password;
    result.externalAccess = true;
    return result;
  }
  static registerByLogin(user, mandant, password) {
    var result = new RegistrationData();
    result.user = user;
    result.mandant = mandant;
    result.password = password;
    return result;
  }
  static registerByAppAutoLogin(hostUrl, password) {
    var result = new RegistrationData();
    result.user = 't';
    result.mandant = 't';
    result.password = password;
    result.hostUrl = hostUrl;
    return result;
  }
  static registerByShorttimePassword(hostUrl, password) {
    var result = new RegistrationData();
    result.pairingToken = password;
    result.hostUrl = hostUrl;
    return result;
  }
}
exports.RegistrationData = RegistrationData;
function setProtocol(url, protocol) {
  const hasPro = url.indexOf('http') === 0;
  const isSecure = url.indexOf('https') === 0;
  if (protocol && hasPro && !isSecure) {
    url = url.substring(url.indexOf(":") + 1);
    url = protocol + ":" + url;
  }
  return url;
}
function responseData2base64(input) {
  var uInt8Array = new Uint8Array(input);
  var i = uInt8Array.length;
  var binaryString = new Array(i);
  while (i--) {
    binaryString[i] = String.fromCharCode(uInt8Array[i]);
  }
  var data = binaryString.join('');
  return window.btoa(data);
}
/** VerbindungsHandler, der die Kommunikation mit dem Server realisiert*/
class ApiConnection {
  /**
   * If possible, provide a PfDeviceResource, representing this device. If the device is already registred
   * and an API-token is set, the Connection will be established automatically
   *
   * Falls möglich eine PfDeviceResource mitgeben, welches das Gerät repräsentiert. Falls das Gerät bereits
   * registriert und schon ein ApiToken vorhanden ist, wird die Verbindung sofort hergestellt.
   **/
  constructor(connactableResource) {
    this.connactableResource = connactableResource;
    this.ready = new Promise((resolveFn, rejectFn) => {
      // Mit dieser Funktion setzen wir uns ready und informieren
      // gleichzeitig alle Wartenden. Da das Promise "this.ready"
      // allerdings bereits rejected sein kann, ersetzen wir es
      // zuvor noch durch ein Promise.OK, damit diese Apiconnection
      // in jedem Fall als "ready" akzeptiert wird
      this.iAmReady = () => {
        // Alle zukünftigen Abragen bekommen ein OK
        this.ready = Promise.resolve();
        // Alle wartenden Abfragen werden resolved
        resolveFn();
      };
      this.iAmError = rejectFn;
    });
    if (connactableResource instanceof resources_1.PfDeviceResource) {
      this.resDevice = this.connactableResource;
    } else {
      this.resInterface = this.connactableResource;
    }
    if (this.resDevice && this.resDevice.getToken() && this.resDevice.getAPIHost()) this.connect(this.resDevice);
  }
  get forceProtocol() {
    return this._forceProtocol;
  }
  set forceProtocol(value) {
    this._forceProtocol = value;
  }
  /**
   * Reconnect to the Server, a device including the API-Token has to be set, or has to be provided.
   * (This method loads the device resource from the server, so we know if the connection works)
   *
   * Verbindung wiederherstellen. Es muss ein Device mit Token gesetzt sein oder übergeben werden.
   * (Diese Methode lädt die DeviceResource frisch vom Server, so dass wir wissen ob die Verbindung funktioniert)
   **/
  connect(resourceToConnectWith, connectWithProtocol) {
    resourceToConnectWith = resourceToConnectWith || this.connactableResource;
    if (resourceToConnectWith) {
      if (connectWithProtocol) this.forceProtocol = connectWithProtocol;
      this.connactableResource = resourceToConnectWith;
      if (resourceToConnectWith instanceof resources_1.PfDeviceResource) {
        // Hier nutzen wir eine Device Resource zum connecten
        this.resDevice = resourceToConnectWith;
        if (this.resDevice && this.resDevice.getToken() != null) {
          let token = this.resDevice.getToken();
          this.loadDTO(ApiConnection.createCompleteLoadUrl(this.resDevice, this.resDevice)).then(loadedDeviceDTO => {
            // Device aktualisieren
            this.resDevice.apiData = JSON.parse(loadedDeviceDTO);
            this.resDevice.setToken(token);
            console.log("API-Connection established");
            // Promise resolven
            this.iAmReady();
          }).catch(reason => {
            this.iAmError(reason);
          });
        }
      }
      if (resourceToConnectWith instanceof resources_1.PfInterfaceResource) {
        // Hier nutzen wir eine Interface Resource zum connecten
        this.resInterface = resourceToConnectWith;
        if (this.resInterface && this.resInterface.apiData.password && this.resInterface.getAPIHost() && this.resInterface.apiData._id) {
          const password = this.resInterface.apiData.password;
          this.loadDTO(ApiConnection.createCompleteLoadUrl(this.resInterface, this.resInterface)).then(loadedInterfaceDTO => {
            this.resInterface.apiData = JSON.parse(loadedInterfaceDTO);
            this.resInterface.apiData.password = password;
            console.log("API-Connection established");
            // Promise resolven
            this.iAmReady();
          }).catch(reason => {
            this.iAmError(reason);
          });
        } else {
          this.iAmError("No interface login data");
        }
      }
    } else {
      this.iAmError("No credentials set. Please login to obtain an API-Token or use interface login data");
    }
    return this.ready; //Unser Promise
  }
  /** Die DeviceResource */
  getDevice() {
    return this.resDevice;
  }
  getConnectableResource() {
    return this.connactableResource || this.resDevice || this.resInterface;
  }
  loadImageSrc(href) {
    var result = new dto_1.ImageInlineData();
    result.href = href;
    this.loadImageData(result);
    return result;
  }
  loadImageData(img) {
    if (img && img.href) {
      let loadUrl = img.href;
      if (loadUrl) return this.loadFile(img.href).then(response => {
        img.src = URL.createObjectURL(response);
        return img;
      }).catch(() => {
        return img;
      });
    } else {
      if (!img) {
        img = new dto_1.ImageInlineData();
      } else {
        img.href = null;
        img.src = null;
      }
      return Promise.resolve(img);
    }
  }
  /**
   * data sollte anmelden daten haben  (zb. mail passwort; name mandant pw)
   * @param data
   */
  register(data) {
    if (ApiConnection.debug) {
      var regDataString = "";
      if (data.user) regDataString += " user:" + data.user;
      if (data.email) regDataString += " email:" + data.email;
      if (data.mandant) regDataString += " mandant:" + data.mandant;
      if (data.password) regDataString += " password: <yes>";
      if (data.pairingToken) regDataString += ' pairingToken: <yes>';
      console.log("starting register for data: ", regDataString);
    }
    if (!data.password && !data.pairingToken) {
      let reason = "Kein Passwort zum registrieren vorhanden.";
      this.iAmError(reason);
      return Promise.reject(reason);
    }
    if (data.email) {
      this.connactableResource.apiData.password = data.password;
      // nur die DeviceResource kann ext Access
      this.resDevice.apiData.externalAccess = data.externalAccess;
      // nur die DeviceResource hat eine Mailadresse
      this.resDevice.apiData.email = data.email;
    } else if (data.user && data.mandant) {
      var credentials = data.user + "@" + data.mandant + ":" + data.password;
    } else if (data.pairingToken) {
      this.resDevice.apiData.pairingToken = data.pairingToken;
    }
    var apiHost = data.hostUrl ? data.hostUrl + "/api" : this.connactableResource.getAPIHost();
    var _thisApiConnection = this;
    const forceProtocol = this.forceProtocol;
    return new Promise((resolveFn, rejectFn) => {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', setProtocol(apiHost, forceProtocol) + "/device", true);
      if (!data.email && !data.pairingToken) xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.onload = function (e) {
        if (xhr.status === 200) {
          let completeDevice = new resources_1.PfDeviceResource(JSON.parse(xhr.response));
          completeDevice.setToken(completeDevice.getToken());
          _thisApiConnection.setDevice(completeDevice);
          resolveFn(completeDevice);
          _thisApiConnection.iAmReady();
        } else if (xhr.status >= 400 || xhr.status === 203) {
          let errMsg = JSON.parse(xhr.response);
          rejectFn(errMsg);
        }
      };
      // xhr.addEventListener("error", function (err) {
      //   console.log("error at xhr register: ", err);
      //   _thisApiConnection.iAmError(err);
      // });
      xhr.addEventListener("error", this.makeXhrOnerrorCallback(xhr, rejectFn, 'Registration failed. Please check URL.'));
      xhr.send(JSON.stringify(this.connactableResource.apiData));
    });
  }
  makeXhrOnloadCallback(xhr, resolveFn, rejectFn) {
    return function (e) {
      if (xhr.status >= 200 && xhr.status < 300) resolveFn(xhr.responseType === 'arraybuffer' ? new Blob([xhr.response], {
        type: xhr.getResponseHeader('content-type')
      }) : xhr.response);else if (xhr.response) {
        rejectFn(JSON.parse(xhr.response));
      } else {
        rejectFn({
          message: xhr.statusText
        });
      }
    };
  }
  makeXhrOnerrorCallback(xhr, rejectFn, fallbackErrorMessage) {
    return function (errorEvent) {
      if (errorEvent instanceof ErrorEvent) rejectFn({
        message: errorEvent.message
      });
      rejectFn({
        message: xhr.statusText || fallbackErrorMessage || 'Connection Failed'
      });
    };
  }
  /** Interne Laderoutine, die den JSON-String lädt */
  loadDTO(url) {
    if (!url) {
      throw new Error("url cannot be undefined.");
    }
    let credentials = null;
    let loadUrl = setProtocol(url, this.forceProtocol);
    if (this.connactableResource instanceof resources_1.PfDeviceResource) {
      // this.resDevice = this.connactableResource as PfDeviceResource;
      credentials = this.resDevice.apiData._id + ":" + this.resDevice.getToken();
    } else if (this.connactableResource instanceof resources_1.PfInterfaceResource) {
      // this.resInterface = this.connactableResource as PfInterfaceResource;
      credentials = this.resInterface.apiData._id + ":" + this.resInterface.apiData.password;
    }
    const t = this;
    return new Promise(function (resolveFn, rejectFn) {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', loadUrl, true);
      xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.onload = t.makeXhrOnloadCallback(xhr, resolveFn, rejectFn);
      xhr.onerror = t.makeXhrOnerrorCallback(xhr, rejectFn);
      xhr.send();
    });
  }
  /** Interne Löschmethode */
  deleteDTO(url) {
    if (!url) {
      throw new Error("url cannot be undefined.");
    }
    const forceProtocol = this.forceProtocol;
    if (this.connactableResource instanceof resources_1.PfDeviceResource) {
      var credentials = this.resDevice.apiData._id + ":" + this.resDevice.getToken();
    } else if (this.connactableResource instanceof resources_1.PfInterfaceResource) {
      var credentials = this.resInterface.apiData._id + ":" + this.resInterface.apiData.password;
    }
    const t = this;
    return new Promise(function (resolveFn, rejectFn) {
      var xhr = new XMLHttpRequest();
      xhr.open('DELETE', setProtocol(url, forceProtocol), true);
      xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.onload = t.makeXhrOnloadCallback(xhr, resolveFn, rejectFn);
      xhr.onerror = t.makeXhrOnerrorCallback(xhr, rejectFn);
      xhr.send();
    });
  }
  /** Interne Speichermethode */
  storeDTO(url, data, isCreate, progressfunction) {
    if (!url) {
      throw new Error("url cannot be undefined.");
    }
    const forceProtocol = this.forceProtocol;
    if (this.connactableResource instanceof resources_1.PfDeviceResource) {
      var credentials = this.resDevice.apiData._id + ":" + this.resDevice.getToken();
    } else if (this.connactableResource instanceof resources_1.PfInterfaceResource) {
      var credentials = this.resInterface.apiData._id + ":" + this.resInterface.apiData.password;
    }
    const t = this;
    return new Promise(function (resolveFn, rejectFn) {
      var xhr = new XMLHttpRequest();
      xhr.open(isCreate ? 'POST' : 'PUT', setProtocol(url, forceProtocol), true);
      xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.onload = t.makeXhrOnloadCallback(xhr, resolveFn, rejectFn);
      xhr.onerror = t.makeXhrOnerrorCallback(xhr, rejectFn);
      if (progressfunction) xhr.upload.addEventListener("progress", function (event) {
        progressfunction(event.loaded, event.total);
      });
      xhr.send(JSON.stringify(data));
    });
  }
  loadFile(url, progressfunction) {
    const forceProtocol = this.forceProtocol;
    if (this.connactableResource instanceof resources_1.PfDeviceResource) {
      var credentials = this.resDevice.apiData._id + ":" + this.resDevice.getToken();
    } else if (this.connactableResource instanceof resources_1.PfInterfaceResource) {
      var credentials = this.resInterface.apiData._id + ":" + this.resInterface.apiData.password;
    }
    const t = this;
    return new Promise(function (resolveFn, rejectFn) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', setProtocol(url, forceProtocol), true);
      xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.responseType = "arraybuffer";
      xhr.onload = t.makeXhrOnloadCallback(xhr, resolveFn, rejectFn);
      xhr.onerror = t.makeXhrOnerrorCallback(xhr, rejectFn);
      if (progressfunction) {
        xhr.upload.addEventListener("progress", function (event) {
          progressfunction(event.loaded, event.total);
        });
      }
      xhr.send();
    });
  }
  storeFile(url, file, method, progressfunction, additionalFormData) {
    if (!url) {
      throw new Error("url may not be undefined.");
    }
    const forceProtocol = this.forceProtocol;
    if (this.connactableResource instanceof resources_1.PfDeviceResource) {
      var credentials = this.resDevice.apiData._id + ":" + this.resDevice.getToken();
    } else if (this.connactableResource instanceof resources_1.PfInterfaceResource) {
      var credentials = this.resInterface.apiData._id + ":" + this.resInterface.apiData.password;
    }
    const t = this;
    return new Promise(function (resolveFn, rejectFn) {
      var xhr = new XMLHttpRequest();
      xhr.open(method || 'POST', setProtocol(url, forceProtocol), true);
      xhr.setRequestHeader("Authorization", "Basic " + window.btoa(credentials));
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.onload = t.makeXhrOnloadCallback(xhr, resolveFn, rejectFn);
      xhr.onerror = t.makeXhrOnerrorCallback(xhr, rejectFn);
      if (progressfunction) {
        xhr.upload.addEventListener("progress", function (event) {
          progressfunction(event.loaded, event.total);
        });
      }
      const formData = new FormData();
      formData.append("file", file);
      if (additionalFormData) for (let prop in additionalFormData) formData.append(prop, additionalFormData[prop]);
      xhr.send(formData);
    });
  }
  buildUrl(storage) {
    var url = "";
    if (!storage.resource) return url; // Dann ist der Rest auch egal
    url += storage.resource;
    if (storage.matrix) {
      if (storage.matrix.indexOf(';') === 0) {
        storage.matrix = storage.matrix.substring(1);
      }
      url += ";" + storage.matrix;
    }
    if (storage.query) {
      if (storage.query.indexOf('?') === 0) {
        storage.query = storage.query.substring(1);
      }
      url += "?" + storage.query;
    }
    if (storage.nocacheValue) {
      if (storage.nocacheValue.indexOf('?') === 0 || storage.nocacheValue.indexOf('&') === 0) {
        storage.nocacheValue = storage.nocacheValue.substring(1);
      }
      var sign = url.indexOf('?') > 0 ? "&" : "?";
      url += sign + storage.nocacheValue;
    }
    return url;
  }
  setDevice(dev) {
    this.connactableResource = dev;
    this.resDevice = dev;
  }
  static createCompleteLoadUrl(resource, connectResource, template = false) {
    var result = template ? resource.getAPILoadTemplateURL(connectResource) : resource.getAPILoadURL(connectResource);
    if (resource.getMatrixParamsAsString() != null) result += resource.getMatrixParamsAsString();
    if (resource.getQueryParamsAsString() != null) result += resource.getQueryParamsAsString();
    return result;
  }
}
exports.ApiConnection = ApiConnection;
ApiConnection.debug = true;
